var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-agreement-page",domProps:{"innerHTML":_vm._s(_vm.contractData)},on:{"click":_vm.handleLinkClick}})}
var staticRenderFns = []

export { render, staticRenderFns }